import { render } from "./Faculty.vue?vue&type=template&id=27bc1197&scoped=true"
import script from "./Faculty.vue?vue&type=script&lang=js"
export * from "./Faculty.vue?vue&type=script&lang=js"

import "./Faculty.vue?vue&type=style&index=0&id=27bc1197&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27bc1197"

export default script